import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/pages/home/home'
import Prevention from '@/pages/prevention/prevention'
import Cosmetic from '@/pages/cosmetic/cosmetic'
import Restorative from '@/pages/restorative/restorative'
import Surgery from '@/pages/surgery/surgery'
import Invisalign from '@/pages/invisalign/invisalign'
import Implant from '@/pages/implant/implant'
import PatientForm from '@/pages/patient-form/patient-form'
import Insurance from '@/pages/insurance/insurance'
import OurTeam from '@/pages/our-team/our-team'
import ThankYou from '@/pages/thank-you/thank-you'
// const AboutUs = () => import(/* webpackChunkName: "group" */ '@/pages/about-us/about-us')
import Contact from '@/pages/contact/contact'
import Sitemap from '@/pages/sitemap/sitemap'
import PageNotFound from '@/pages/404/404'
import accessibilityStatement from '@/pages/accessibility-statement/accessibility-statement'
import Reviews from '@/pages/reviews/reviews'
import scrollBehavior from '@/shared/functionality/scroll-behavior'
import Styleguide from '@/styleguide/styleguide'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      navigation: true,
      component: Home
    },
    {
      path: '/prevention',
      name: 'prevention',
      navigation: true,
      component: Prevention
    },
    {
      path: '/cosmetic',
      name: 'cosmetic',
      navigation: true,
      component: Cosmetic
    },
    {
      path: '/restorative',
      name: 'restorative',
      navigation: true,
      component: Restorative
    },
    {
      path: '/surgery',
      name: 'surgery',
      navigation: true,
      component: Surgery
    },
    {
      path: '/invisalign',
      name: 'invisalign',
      navigation: true,
      component: Invisalign
    },
    {
      path: '/implant',
      name: 'implant',
      navigation: true,
      component: Implant
    },
    {
      path: '/patient-form',
      name: 'patient-form',
      navigation: true,
      component: PatientForm
    },
    {
      path: '/insurance',
      name: 'insurance',
      navigation: true,
      component: Insurance
    },
    {
      path: '/contact',
      name: 'Contact',
      navigation: true,
      component: Contact
    },
    {
      path: '/our-team',
      name: 'OurTeam',
      navigation: true,
      component: OurTeam
    },
    {
      path: '/thank-you',
      name: 'ThankYou',
      navigation: true,
      component: ThankYou
    },
    {
      path: '/sitemap',
      name: 'Sitemap',
      navigation: true,
      component: Sitemap
    },
    {
      path: '/reviews',
      name: 'Reviews',
      navigation: true,
      component: Reviews
    },
    {
      path: '/accessibility-statement',
      name: 'Accessibility Statement',
      navigation: false,
      component: accessibilityStatement
    },
    {
      path: '/styleguide',
      name: 'Styleguide',
      navigation: false,
      component: Styleguide
    },
    {
      path: '/*',
      name: 'page-not-found',
      navigation: false,
      component: PageNotFound
    }
  ],
  scrollBehavior
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js